<template>
    <div id="hedgingMain">
        <div class="e-card">
            <div id="hedgingForm" class="row" style="padding: 2%">
                <div class="col-lg-8">
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="hedgingYears" ref="hedgingYears" name="hedgingYears" :dataSource='availableYears' :select="onYearSelect" :fields="{text: 'name', value: 'id' }" placeholder="Years" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="hedgingView" ref="hedgingView" name="hedgingView" :dataSource='views' :index='firstIndex' :select="onViewSelect" :fields="{text: 'name', value: 'id' }" placeholder="View" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist ref='dplCurrencyHedg' id="currencyHedg" name="currency" v-model="data.currencyId" :change="onCurrencyChangeHedg" :dataSource='currenciesHedg' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group" v-if="showPriceAreaSection">

                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group" v-if="showPriceAreaSection">
                            <ejs-dropdownlist ref='dplPriceAreaHedg' id="priceAreaHedg" name="priceAreaHedgName" :index='firstIndex' :actionComplete="onActionComplete" :change='onPriceAreaHedgChange' floatLabelType='Auto' :dataSource='priceAreaHedg' :fields="{text: 'name', value: 'id' }" placeholder="Price Area:" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group check-dh" v-if="showPriceAreaSection">

                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="hedgingProduct" ref="hedgingProduct" name="hedgingProduct" :index='firstIndex' :dataSource='products' :dataBound="onProductSelect" :select="onProductSelect" :fields="{text: 'name', value: 'id' }" placeholder="Product" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <div class="col-sm-2 justify-content-end">
                                <ejs-button cssClass="e-primary" v-on:click.native='download'>Hedging Overview 100% stacked</ejs-button>
                            </div>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-checkbox ref="hedgCheckDM" :change="onCheckHedingDefault" label='Default Mechanism' id="HedingCheckDefault" name="checkName" floatLabelType='Auto' cssClass="hedingCheck check-d"></ejs-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                </div>
            </div>
            <div id="hedgingGraph" class="row" style="max-width:100%">
                <div class="col">
                    <ejs-chart id="hedgingChartContainer" ref="priceChart" :title='title' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' style="margin-top: 10px;" :palettes='palettes' :legendSettings='legendSettings'>
                        <e-series-collection>
                            <e-series :dataSource='fixedPriceDataGraph' type='StackingColumn' xName='period' yName='value' name='Fixed' :marker="marker"></e-series>
                            <e-series :dataSource='openPriceDataGraph' type='StackingColumn' xName='period' yName='value' name='Open' :marker="openMarker"></e-series>
                        </e-series-collection>
                    </ejs-chart>
                </div>
            </div>
            <div class="row">
                <div class="col m-3">
                    <ejs-grid ref="gridOpenPrice"
                              :dataSource="openGridData" id="gridOpenPrice"
                              :dataBound="dataBoundOpenPrice"></ejs-grid>
                </div>
            </div>
            <div class="row">
                <div class="col ml-3 mr-3">
                    <ejs-grid ref="gridFixedPrice"
                              :dataSource="fixedGridData" id="gridFixedPrice"
                              :dataBound="dataBoundFixedPrice"></ejs-grid>
                </div>
            </div>
            <div class="row">
                <div class="col m-3">
                    <ejs-grid ref="gridM2mPrice"
                              :dataSource="m2mGridData" id="gridM2mPrice"
                              :dataBound="dataBoundM2mPrice"></ejs-grid>
                </div>
            </div>
        </div>
        <div id="hedgingSpinner"></div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Grid } from "@syncfusion/ej2-vue-grids";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import apis from '../../../common/network'
    import store from '../../../store';
    import urls from '../../../common/urls';
    import SyncHelper from '../../../common/syncfusion';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { isNullOrUndefined } from '@syncfusion/ej2-base';
    import { ChartPlugin, StackingColumnSeries, Category, DataLabel, Legend } from "@syncfusion/ej2-vue-charts";
    import gridOptions from '../../../common/gridOptions'

    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(GridPlugin);
    Vue.use(DialogPlugin);
    Vue.use(ChartPlugin);

    export default {
        name: 'HedgingOverviewReport',
        created() {
        },
        data() {
            return {
                data: {},
                palettes: ["#485696", "#Dae0f2"],
                openGridData: [],
                fixedGridData: [],
                m2mGridData: [],
                unit: null,
                currency: null,
                currencyId: null,
                value: null,
                firstIndex: 0,
                firstIndexCurrency: 3,
                fixedPriceDataGraph: [],
                openPriceDataGraph:[],
                openPriceGrid: null,
                fixedPriceGrid: null,
                m2mPriceGrid: null,
                triggeredFixedPrice: false,
                triggeredOpenPrice: false,
                triggeredM2mPrice: false,
                showPriceAreaSection: false,
                priceAreaNames: store.state.pricingAreaNames,
                openPeriods: [],
                fixedPeriods: [],
                openPriceData: [],
                fixedPriceData: [],
                availableYears: [],
                openMarker: {
                    dataLabel: {
                        visible: true,
                        font: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '13px', fontWeight: 'normal', textAnchor: 'middle' }, position: 'Middle'
                    }
                },
                marker: {
                    dataLabel: {
                        visible: true,
                        font: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '13px', fontWeight: 'normal', textAnchor: 'middle' }, position: 'Middle'
                    }
                },
                legendSettings: {
                    visible: true,
                    position: 'Bottom',
                    textStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '13px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                primaryXAxis: {
                    valueType: 'Category',
                    title: ' ',
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                primaryYAxis:
                {
                    //minimum: 0,
                    //maximum: 100,
                    //interval: 20,
                    title: 'Volume',
                    labelFormat: 'n1',
                    titleStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' },
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' },
                },
                years: null,
                title: "Hedging Overview",
                views: [{ "name": "100% Stacked", "id": 1 }, { "name": "Stacked", "id": 2 }, { "name": "Cost", "id": 3 }],
                allowFiltering: true
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('hedgingSpinner')
            });
            createSpinner({
                target: document.getElementById('mainSpinner')
            });
            showSpinner(document.getElementById('mainSpinner'));
        },
        methods: {
            onActionComplete(args) { //initial load to be set on the first pricing area
                let currencyId = this.$refs.dplCurrencyHedg.ej2Instances.value;
                if (args.result && args.result.length > 0) {
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, args.result[0].id, false);
                }
            },
            onPriceAreaHedgChange: function (args) {
                if (args.isInteracted) {
                    let currencyId = this.$refs.dplCurrencyHedg.ej2Instances.value;
                       
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, args.itemData == null ? null : args.itemData.id, false);

                }
            },
            onCheckPASystemHedg(args) {
                let pricingAreaId = document.getElementById('priceAreaHedg') == null ? undefined : document.getElementById('priceAreaHedg').ej2_instances[0].value;
                let currencyId = this.$refs.dplCurrencyHedg.ej2Instances.value;
                if (args.checked) {
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, true);
                } else {
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, false);
                }
            },
            calculateYears: function (startDate, endDate) {
                this.availableYears = [];
                var startYearMonth = new Date(startDate).getMonth();
                var endYearMonth = new Date(endDate).getMonth();
                var min = new Date(startDate).getFullYear();
                var max = new Date(endDate).getFullYear();
                if (endYearMonth < startYearMonth) {
                    max = max - 1;
                }
                var j = 1;

                for (var i = min; i <= max; i++) {
                    var nextyear = i + 1;
                    var yearName = startYearMonth == 0 ? ("Y" + j + "-" + i) : ("Y" + j + "-" + i + "/" + nextyear);
                    this.availableYears.push({ "name": yearName, "id": j })
                    j++;
                }
                this.$ref.hedgingYears.ej2Instances.value = 1;
            },
            onCheckHedingDefault(args) {
                let pricingAreaId = document.getElementById('priceAreaHedg') == null ? undefined : document.getElementById('priceAreaHedg').ej2_instances[0].value;
                store.state.isCheckDefaultM = args.checked;
                let currencyId = this.$refs.dplCurrencyHedg.ej2Instances.value;
               
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, false);
                
            },
            onViewSelect: function (args) {
                this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, args.itemData.name);
            },
            onProductSelect: function (args) {
                let pricingAreaId = document.getElementById('priceAreaHedg') == null ? undefined : document.getElementById('priceAreaHedg').ej2_instances[0].value;
                var prodName = args.itemData == null ? this.$refs.hedgingProduct.ej2Instances.text : args.itemData.name;
                let currencyId = this.$refs.dplCurrencyHedg.ej2Instances.value;
               
                    this.getHedgingData(prodName, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, false);
                
            },
            onYearSelect: function (args) {
                let pricingAreaId = document.getElementById('priceAreaHedg') == null ? undefined : document.getElementById('priceAreaHedg').ej2_instances[0].value;
                let currencyId = this.$refs.dplCurrencyHedg.ej2Instances.value;
              
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, args.itemData.name, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, false);
                
            },
            onCurrencyChangeHedg: function (args) {
                let pricingAreaId = document.getElementById('priceAreaHedg') == null ? undefined : document.getElementById('priceAreaHedg').ej2_instances[0].value;
                this.currencyId = args?.itemData?.currencyId;
                
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, this.currencyId, pricingAreaId, false);
                

            },
            getHedgingData: function (product, year, view, currencyId, pricingAreaId, pricingAreaSystem) {
                showSpinner(document.getElementById('hedgingSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`report/hedgingOverviewATG/${store.state.reportTradingGroupId}?product=${product}&year=${year}&view=${view}&currencyId=${currencyId == undefined ? "" : currencyId}
                &defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}&pricingAreaId=${pricingAreaId == undefined ? "" : pricingAreaId}&pricingAreaSystem=${pricingAreaSystem == undefined ? false : pricingAreaSystem}`)
                    .then(response => {
                        this.data = response.data.data;
                        this.bindGrids(view);
                        this.unit = response.data.unit;
                        this.currency = response.data.currency;
                        this.currencyId = response.data.currencyId;
                        this.value = response.data.value;

                        if (response.data.value == 'p/therm') {

                            this.$refs.dplCurrencyHedg.ej2Instances.text = "p - GBp";

                        } else {

                            this.$refs.dplCurrencyHedg.ej2Instances.text = response.data.currencySymbolAndName;
                        }
                        this.calculateYears(response.data.startDate, response.data.endDate);
                   
                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }).catch(e => {
                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            download: function (args) {
                showSpinner(document.getElementById('hedgingSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                this.currencyId = this.$refs.dplCurrencyHedg.ej2Instances.value;
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateHedgingATGReportPage/${store.state.reportTradingGroupId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&defaultM=${this.$refs.hedgCheckDM.ej2Instances.checked}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('hedgingSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            }, 
            bindGrids: function (view) {

                this.openGridData = this.data.open;
                this.fixedGridData = this.data.fixed;
                this.m2mGridData = this.data.m2m;
                this.openPriceDataGraph = [];
                for (const property in this.data.open[2]) {
                    var s = {
                        period: property,
                        value: this.data.open[2][property].replaceAll(",", "")
                    };
                    if (property != "Open") {
                        this.openPriceDataGraph.push(s);
                    }
                }
                this.fixedPriceDataGraph = [];
                for (const property in this.data.fixed[1]) {
                    var s = {
                        period: property,
                        value: this.data.fixed[1][property].replaceAll(",", "")
                    };
                    if (property != "Fixed") {
                        this.fixedPriceDataGraph.push(s);
                    }
                }

                var maxHeight="0";
                var minHeight = "0";

                for (var i = 0; i < this.fixedPriceDataGraph.length; i++) {
                    if (parseInt(this.fixedPriceDataGraph[i].value.replaceAll(",", "")) > parseInt(maxHeight.replaceAll(",", ""))) {
                        maxHeight = this.fixedPriceDataGraph[i].value;
                    }
                    if (parseInt(this.fixedPriceDataGraph[i].value.replaceAll(",", "")) < parseInt(minHeight.replaceAll(",", ""))) {
                        minHeight = this.fixedPriceDataGraph[i].value;
                    }
                }
                for (var i = 0; i < this.openPriceDataGraph.length; i++) {
                    if (parseInt(this.openPriceDataGraph[i].value.replaceAll(",", "")) > parseInt(maxHeight.replaceAll(",", ""))) {
                        maxHeight = this.openPriceDataGraph[i].value;
                    }
                    if (parseInt(this.openPriceDataGraph[i].value.replaceAll(",", "")) < parseInt(minHeight.replaceAll(",", ""))) {
                        minHeight = this.openPriceDataGraph[i].value;
                    }
                }
                var chart = document.getElementById('hedgingChartContainer').ej2_instances[0];
                if (view == "100% Stacked") {
                    chart.primaryYAxis =
                    {
                        //minimum: 0,
                        //maximum: 100,
                        //interval: 20,
                        title: 'Volume %',
                        labelFormat: 'N1'
                    }
                }

                else if (view == "Stacked") {
 
                        chart.primaryYAxis =
                        {
                            //minimum: (parseInt(minHeight.replaceAll(",", "")) > 10) ? parseInt(minHeight.replaceAll(",", ""))-10 : 0,
                            //maximum: parseInt(maxHeight.replaceAll(",", ""))*2,
                            //interval: ((parseInt(maxHeight.replaceAll(",", ""))*2) - parseInt(minHeight.replaceAll(",", ""))) / 10,
                            title: 'Volume ' + this.unit,
                            labelFormat: 'N2'
                        }
                   
                    
                }
                else {//cost
                    chart.primaryYAxis =
                    {
                        //minimum: (parseInt(minHeight.replaceAll(",", "")) > 10) ? parseInt(minHeight.replaceAll(",", "")) - 10 : 0,
                        //maximum: parseInt(maxHeight.replaceAll(",", ""))*2,
                        //interval: ((parseInt(maxHeight.replaceAll(",", ""))*2) - parseInt(minHeight.replaceAll(",", ""))) / 10,
                        title: 'Cost ' + this.value,
                        labelFormat: 'N0'
                    }
                    this.openMarker = {
                        dataLabel: {
                            visible: true,
                        }
                    }
                }
                chart.refresh();
                this.triggeredOpenPrice = false;
                this.triggeredFixedPrice = false;
                this.triggeredM2mPrice = false;
                setTimeout(function (e) {
                    e.refresh();
                }, 0, this.$refs.gridOpenPrice);
                
                setTimeout(function (e) { e.refresh();}, 50, this.$refs.gridFixedPrice);
                setTimeout(function (e) {
                    e.refresh();
                }, 150, this.$refs.gridM2mPrice);

               
            },
            
            dataBoundOpenPrice: function () {
                if (this.triggeredOpenPrice == false) {
                    this.dataBound(this.$refs.gridOpenPrice);
                }
                this.triggeredOpenPrice = true;
            },
            dataBoundFixedPrice: function () {
                if (this.triggeredFixedPrice == false) {
                    this.dataBound(this.$refs.gridFixedPrice);
                }
                this.triggeredFixedPrice = true;
            },
            dataBoundM2mPrice: function () {
                if (this.triggeredM2mPrice == false) {
                    this.dataBound(this.$refs.gridM2mPrice);
                }
                this.triggeredM2mPrice = true;
            },
            dataBound: function (grid) {
                var cols = Object.keys(grid.getCurrentViewRecords()[0]);
                var length = cols.length;
                var col = [];
                for (var i = 0; i < length; i++) {
                    var field = cols[i];
                    var obj = {};
                    
                    obj["field"] = field;
                    if (field == "Open" || field == "Fixed" || field == "M2M") {
                        obj["width"] = 190;
                    }else{
                        obj["width"] = 120;
                    }
                    col.push(obj);
                }
                grid.setProperties({ columns: col });
            },

            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' }
                });
            },
            populateChart: function (data) {

            },

        },
        computed: {
            products() {
                return SyncHelper.getDataManager("utils/products?tradingGropuId=" + store.state.reportTradingGroupId + "&includeCombined=true");
            },
            currenciesHedg() {
                return SyncHelper.getDataManager("utils/currenciesAvailable?tradingGroupId=" + store.state.reportTradingGroupId);
            },
            priceAreaHedg() {
                return SyncHelper.getDataManager("utils/pricingContractAreas?tradingGroupId=" + store.state.reportTradingGroupId);
            }
        },
        provide: {
            chart: [StackingColumnSeries, Category, DataLabel, Legend]
        },
        updated: function () {
            this.$nextTick(() => {
                window.dispatchEvent(new Event('resize'));
            });
        },
    }

</script>

<style>
    .hedingCheck {
        padding: 1em 24em 0em 0em;
    }

    #hedgingChartContainer_ChartTitle {
        font-style: normal;
        font-size: 15px;
        font-weight: 500;
        text-anchor: middle;
        fill: #8a93a2;
    }

    #hedgingSpinner {
        display: none;
    }
</style>